/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { SharedDataCache } from '../../core/common/shared.data';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcErrorComponent),
    multi: true
};

/**
 * Error
 */
@Component({
    selector: 'ngc-error',
    template: `
            <label class="jqx-validator-error-label jqx-validator-error-label-light" 
                style="position: relative; left: 0px; top: 0px; font-weight: normal; font-size:12px"
                *ngIf="value">{{value}}</label>
            `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcErrorComponent extends ControlComponent {

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
}

/**
 * Error Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcErrorComponent],
    declarations: [NgcErrorComponent]
})
export class NgcErrorModule {
}